import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { BoReference } from './bo-reference.js'
import { RestrictableItemRestriction } from './restrictions/restrictable-item-restriction.js'
import { BoVisitor } from './bo-visitor.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

@jsonClass('AccessControl')
export class AccessControl extends BusinessObject {
	@jsonArrayProperty(BoReference)
	coveredBos: BoReference[] = []

	@jsonArrayProperty(RestrictableItemRestriction)
	restrictions: RestrictableItemRestriction[] = []

	constructor(init?: Partial<AccessControl>) {
		super()
		assignCommonProperties(this, init)
	}

	isBoCovered(bo: BusinessObject | BoReference) {
		const boRef = this.coveredBos.find((ref) => ref.matches(bo))
		return !!boRef
	}

	getRestrictionForBo(boRef: BoReference, itemName: string) {
		if (!this.isBoCovered(boRef)) return null
		const restriction = this.restrictions.find((r) =>
			r.matches({
				...boRef,
				itemName,
			}),
		)
		return restriction
	}

	getClassNames(): string[] {
		return [this.getQualifiedName()]
	}

	visit(visitor: BoVisitor): void {
		this.coveredBos.forEach((boRef) =>
			visitor.visitBoReference(boRef, ['coveredBos']),
		)
		this.restrictions.forEach((restriction) => {
			visitor.visitTsCode(
				restriction.restrictionCode,
				restriction,
				'restriction',
				[
					'restrictions',
					restriction.getQualifiedTypeAndName(),
					restriction.itemName,
					'code',
				],
				(newCode) => (restriction.restrictionCode = newCode),
			)
		})
	}
}
